export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Order Timeout",
      "649f8aefc1c0": "Recycling Failed",
      "649f8aefc9c0": "Sell now",
      "TradeIn": "Trade-in process",
      "logistic": 'Download shipping label',
      "start": "Start Journey",
      "success": "Your order has been successfully placed on our website.",
      "qc": "Old Device QC",
      "business": "We will complete your old device inspection within 1-2 working days",
      "completed": "Completed",
      "successfully": "Congratulations your trade-in are successfully",
      "orderInfor": "Order information",
      "orderID": "Recycling order number",
      "orderNum": "New device order number",
      "createTime": "Creation time",
      "brand": "Estimated brand",
      "model": "model",
      "price": "Old device price",
      "bonus": "Bonus",
      "total": "Total price",
      "logisticInfo": "Logistics information",
      "available": "No logistics information available",
      "logisticNum": "Logistics number",
      "failRey": "We apologize that your participation in the OnePlus recycling program was not successfully completed. If you have a recycling plan for other electronic products, you can click the button below for a quick estimate!!",
      "userRes": "The user has already rejected the offer.",
      "successPrice": "The following price is after professional inspection. If you agree with this price, you can proceed with the trade-in. If you reject it, the device will be sent back to you in a few working days.",
      "sure": "agree",
      "Reject": "Reject",
      "congratulation": "Congratulations QC No difference.",
      "finPirce": "Final price",
      "copySuccess": "Copy Success",
      "copyfail": "Copy Failure",
      "sureSuccess": "Confirm successful transaction",
      "submitError": "Submission failed",
      "detectionResult": "detection result",
      "Collected": "Collected",
      "inTransit": "In transit/Shipping",
      "656g0lj3sav6": "recycling process",
      "656g0lj3cd5a": "Correctly fill in your personal information and successfully place the order",
      "656g0lj3dr9a": "The inspection of your mobile phone will be completed within 48 hours of its arrival at our center",
      "656g0lj3epal": "Once the inspection is complete, we will contact you with a final offer via email",
      "656g0lj3pda2": "Your estimate",
      "656g0lj3ed3d": "Professional quality check",
      "656g0lj3esf3": "Copy",
      "expertDiscount": "推广码补贴",  // 推广码补贴
      "invalidCode": "invalidCode",
      "toastTip": "Check to accept Privacy Policy & Terms."
    },
    "btnDialog": {
      "64a9shqq2ks0": "Refuse to recycle",
      "64a9shqq3k00": "You confirm that you refuse to recycle",
      "64a9shqq3r00": "Cancel Success",
      "64a9shqq3ws0": "Cancellation failed",
      "sureCancel": "Confirm cancel"
    }
  },
  model: {
    noModelYet: '暂无机型',
    answerTip01: '您可在手机的 | 【设置】-【通用】-【监管】 | 找到型号',
    answerTip02: 'N开头是官换机；F开头是官翻机/官修机；3开头是 展示机；',
    answerTip03: '有锁无锁？',
    answerTip04: ' 插上其他卡看是否能正常通话辨别有无锁，有锁一般需要激活，无法正常通话。',
    answerTip05: '其中CH是中国市场的机器，ZP是香港市场的机器，不是CH/ZP，是便携的。',
    newModelCheck: '新机校验',
    chooseOrNot: '可选可不选',
    tip35: '不回收此类机型',
  },
  other: {
    mustWrite: '必填',
    lijiTakePhoto: '立即拍照',
    callNum: '拨号',
    takePhotoUpload: '拍照上传',
    buChongDesc: '补充说明',
    buChongTakePhoto: '补充拍照',
    buChongTakePhoto_2: '补充拍照',
    null: '无',
    fold: '收起',
    unfoldAllDiff: '展开所有差异项',
    lookMoreDiffPieces: '查看更多差异项',
    loadFail: '加载失败',
    loadSuccess: '加载成功',
    warmTip: '温馨提示',
    tip: '提示',
    yesISure: '是的，我已确认',
    next: '下一步',
    continueWait: '继续等待',
    cancel: '取消',
    guKeFullName: '顾客姓名',
    guKePhone: '顾客手机',
    vertifyCode: '验证码',
    getVertifyCode: '获取验证码',
    rePost: '重新发送',
    hasAutomaticSaveMsg: '已自动保存上方信息',
    canUpDownScrollLook: '可上下滑动查看',
    shiliTu: '示例图',
    submit: '提交',
    msgVertify: '信息验证',
    gouJiMsg: '购机信息',
    look: '查看',
    sure: '确认',
    sured: '已确认',
    payToGuKe: '付款给顾客',
    isSureTransaction: '是否确认交易？',
    surePay: '确认付款',
    transactionFinish: '交易完成',
    sureUserHadTransated: '确认用户已交易',
    payFinish: '付款完成',
    hadPayToGuKe: '已付款给顾客',
    continueToPayToGuKe: '继续付款给顾客',
    huanXin: '换新',
    moneyJieSuanCount: '金额结算账户',
    loading: '加载中...',
    reLoad: '重新加载',
    paying: '付款中',
    plsPayToKeHu: '请付款给客户',
    submitFail: '提交失败',
    other: '其它',
    validateFail: '验证失败',
    scanCodeFail: '扫码失败',
    clickTakePhoto: '点击拍照',
    phone: '手机',
    wristWatch: '手表',
    erji: '耳机',
    ipad: '平板',
    all: '全部',
    plsInput: '请输入',
    inputOrScan: '可手动输入或扫一扫',
    phoneNum: '手机号',
    account: '账号',
    password: '密码',
    dianYuanID: '店员ID',
    handleResulting: '正在处理结果',
    jianDingResult: '鉴定结果',
    sendJianDingTime: '发送鉴定时间',
    errorOccurred: '发生错误',
    agentManager: '代理经理',
    fullName: '姓名',
    phoneNum: '手机号码',
    role: '身份',
    shoper: '门店店长',
    dianZhang: '店长',
    dianYuan: '店员',
    shoperPhoneNum: '店长手机号',
    belongShop: '所属门店',
    shopID: '门店ID',
    shopCategory: '门店类别',
    belongShangDian: '所属商店',
    shengShiQu: '省市区',
    detailAddress: '详细地址',
    dianPu: '店铺',
    add: '添加',
    qiYongIng: '启用中',
    leaveShop: '离店',
    fail: '失败',
    success: '成功',
    addAgentManager: '增加代理经理',
    accountMsg: '账户信息',
    dianYuanFullName: '店员姓名',
    pcName: 'PC姓名',
    plsSetMustSet: '请填写（必填）',
    noYet: '暂无',
    iKonw: '我知道了',
    problem1: '无法开机/无法进入桌面',
    plsCheckError: '请检查错误项',
    refreshSuccess: '刷新成功',
    requestFail: '请求失败',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    newerOperateGuide: '新手操作指南',
    saleSkillJinJie: '销售技巧进阶',
    phoneKonwledgeClass: '手机知识课堂',
    pay: '付款',
    submitShenSu: '提交申诉',
    fuHeRecord: '复核记录',
    yuEr: '余额',
    tiXian: '提现',
    myRedPackage: '我的红包',
    redPackage: '红包',
    rmb: '฿',
    shot: '拍摄',
    otherProblem: '其他问题',
    bottomLine: '我也是有底线的', //没有更多数据了
    noDataYet: '暂时没有数据',
    chooseOrNot: '可选可不选',
    selectShenSuOption: '请选择需要申述的选项',
    shenSuShuoMing: '申诉说明',
    plsInputShenSuReason: '请填写申诉理由',
    commitShenSu: '确定提交申诉',
    shenSuReasonZiShu: '申诉理由限{n1}字',
    plsWriteFuHeResult: '复核申诉已提交，请等待复核结果',
    clerkMsg: '店员信息',
    total: '总计',
    plsSelect: '请选择',
    customerMsg: '顾客信息',
    customerIDCard: '顾客身份证号',
    uploadCustomerIDCardZheng: '顾客证件正面',
    customerPhone: '顾客手机号',
    printContract: '打印合同',
    backHome: '返回首页',
    sureDeal: '确认交易',
    createBarCode: '生成条形码',
    barCode: '条形码',
    clerkType: '店员类型'
  },
  pc: {
    preOne: '预估最高价格：',
  },
  "home": {
    "whoAreWe": {
      "646u995ltgw0": "who",
      "646u995lv9g0": "Are we",
      "646u9d5lv9g0": "eSwop is a company with a core business focused on the recycling, disposal, and sale of 3C digital products such as mobiles, tablets, laptops, and watches. Our company is dedicated to accelerating the recycling efficiency of electronic products and promoting the healthy development of the second-hand market. Currently, we have established official strategic partnerships with OPPO, Vivo, OnePlus, Realme, and others. Our overseas business has expanded to India, Thailand, Vietnam, Cambodia, and now Europe.",
      "646u995dv9g0": "Our global presence has positioned us as a strategic partner for mobile operators, manufacturers, and wholesalers with both continental and transcontinental reach.",
      "646u99slv9g0": "We collaborate with leading manufacturers and maintain a diverse inventory that includes low, mid and high-end devices. This enables us to provide customized solutions and competitive pricing to meet the needs of our customers."
    },
    "business": {
      "646v04syvpk0": "Are you interested in purchasing our stock?",
      "646v04syxs80": "At eSwop, we provide a comprehensive selection of mobile phones, tablets and smartwatches, and available across various grading levels to meet diverse business requirements.",
      "646v04syy6g0": "Contact our Sales&Purchase Manager :",
      "646v04syya80": "I Want To Buy",
      "646v04syydg0": "请输入你的名字",
      "646v04syyh40": "请输入你的phone",
      "646v04syykc0": "请选择",
      "646v04syyyw0": "请输入你的email",
      "646v0gsyz1s0": "Country:",
      "646v04syz1s0": "请选择选项",
      "646v04syz4o0": "I have read and accept the",
      "646v04syzkc0": "Privacy Policy",
      "646v04syzok0": "联系我们",
      "646v04syzso0": "请选择区号",
      "646v04syzvo0": "请你的手机号",
      "646v04syzys0": "请输入email",
      "646v04sz01o0": "请输入正确的email",
      "646v04sz04g0": "请输入你的姓名",
      "646v04sz0740": "请勾选方框表示同意隐私政策",
      "646v04sz0a00": "提交成功",
      "646v04sz0cw0": "提交失败",
      "title1": "Transparent Mobile Grading",
      "text1-1": "To support your purchasing decisions, we encourage you to review our detailed Grading document. It outlines the aesthetic and functional standards of each grade, enabling you to make well-informed choices that align with your expectations.",
      "title2": "Exceptional Client Support",
      "text2-1": "We recognize the unique needs of each client, which is why our team of multilingual sales professionals is dedicated to delivering tailored and expert assistance.",
      "title3": "Commitment to Sustainable Technology",
      "text3-1": "We are committed to advancing global access to sustainable technology solutions, ensuring that our processes create value for all stakeholders involved.",
      "text3-2": "For further inquiries or to arrange a  trial order, please contact us. Our team is ready to assist you with professionalism and care."
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "关于eSwop",
      "646ntjwmn580": "商务",
      "646nt7hwils0": "联系我们",
      "646nt7hwipg0": "去购买",
      "646nt7hwis00": "去回收"
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "仅需4步，快速回款",
      "s1": "First step",
      "s1t": "Pack your device so that it arrives in the same condition it was in when it was sent.",
      "s2": "The second step",
      "s2t": "Deliver your package at our Drop-Off Point.",
      "s3": "The third step",
      "s3t": "Let’s check out your device and get you a quote.",
      "s4": "Step four",
      "s4t": "Get paid fast."
    },
    "section3": {
      "646tmse2fbo0": "手机",
      "646tmse2mv00": "敬请期待",
      "title": "Quick valuation",
      "t1": "Select the type and start valuation, get a fair quote.",
      "t2": "Simple steps, enjoy our quick recycling service !",
    },
    "section6": {
      "646txzpazuc0": "关于企业",
      "666txzpazuc0": "eswop，一家专注于手机和平板的回收与再利用的公司，致力于通过简单、安全、高效的服务流程，让每一位用户都能轻松实现设备的循环利用。",
      "646txzpb0rk0": "查看详情",
      "646txzpb0xc0": "支持12回收品牌"
    },
    "section7": {
      "646ns2k5f7k0": "我们将竭诚为您服务",
      "646ns2k5gmw0": "周一至周五上午9:00至下午6:00 CET（UTC+01:00）西班牙马德里",
      "646ns2k5gs40": "请输入你的名字",
      "646ns2k5gx40": "请输入你的phone",
      "646ns2k5h0s0": "请选择",
      "646ns2k5img0": "请输入你的email",
      "646ns2k5isw0": "请留言",
      "646ns2k5iws0": "联系我们",
      "646ns2k5iz40": "请选择区号",
      "646ns2k5j140": "请你的手机号",
      "646ns2k5j4g0": "请输入email",
      "646ds2k5j4g0": "Email",
      "646ns2k5j6c0": "请输入正确的email",
      "646ns2k5j8g0": "联系电话",
      "646ns2k5jak0": "税号",
      "646ns2k5jck0": "地址",
      "646ns2s5jck0": "Calle Tomás Bretón, 46, Planta 1, Oficina 5, 28045 Madrid, España",
      "646ns2k5jgc0": "请输入你的姓名",
      "646ns2k5ji40": "请勾选方框表示同意隐私政策",
      "646ns2k5jk00": "提交成功",
      "646ns2k5jm80": "提交失败",
      "646ny1rgz3c0": "我已阅读并接受",
      "646ny1rh2k40": "隐私协议"
    },
    "successMain": {
      "647qmd42l1s0": "下单成功！",
      "647qmd42mss0": "请关注邮箱号noreply@eswop.eu给您发送的寄出指引邮件",
      "647qmd42mz80": "预估价值",
      "647qmd42yeo0": "温馨提示",
      "orderTime": "下单时间",
      "text1": "免费物流",
      "text2": "请关注邮件中给您发送的物流运单",
      "text3": "数据备份",
      "text4": "为保护您的数据安全,我们会清楚您的全部数据或初始化",
      "text5": "充电",
      "text6": "为更快帮助您完成检测,请提前给就手机充电"
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Social Media",
      "646d71qugz40": "Easy payment",
      "646u51qugz40": "Logistic",
      "646u5dqui780": "Privacy Policy",
      "646uddqui780": "Terms and Conditions",
      "646u51qui780": "FAQs"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "免费估价"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "请输入",
      "646wgb1nj8o0": "搜索词",
      "646wgb1nji80": "我触发搜索上拉了",
      "empty": "暂无机型喔",
      "confirm": '确认',
      "cancle": "取消",
      "dialogText": 'Are you sure to delete all history records?'
    }
  },
  "PCProduct": {
    "empty": "暂无机型喔"
  },
  "PCBrandTab": {
    "index": "品牌"
  },
  "PCCategoryTab": {
    "index": "类别"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "线上下单",
      "646xagqwkuw0": "平台包邮寄出",
      "646xagqwmao0": "专业质检",
      "646xagqwmlc0": "极速打款"
    }
  },
  "router": {
    "selectModel": "机型",
    "selectProperty": '机况问题',
    "price": "预估价",
    "priceOrder": '下单',
    "orderSuccess": "下单成功"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "重新选择机型",
      "646ymq6ot0k0": "提示",
      "646ymq6pd100": "出售前请务必将旧设备云账号/",
      "646ymq6pekw0": "屏幕锁/Apple ID账户退出。"
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "请选择机况",
      "647h1f4yr6c0": "预估回收价",
      "647h1f4yso80": "预估补贴",
      "text1": "免费物流",
      "text2": "我们会提供免费的旧机回收物流服务",
      "text3": "快速打款",
      "text4": "回收完成后,1-2个工作日完成付款",
      "64tve23zt0g0": "免费运输和销售包装",
      "64tve23zup00": "安全数据擦除",
      "64tve23zuy40": "不满意？免费退货",
      "64tve23zv7g0": "收到设备后1-2个工作日付款",
      "64tve23zvbg0": "选择您的送货方式",
      "64tve23zvf80": "您有10天时间寄送您的手机",
      "64tve23zvjc0": "将运输标签发送到您的电子邮件，并免费寄送您的手机。",
      "64tve23zvms0": "打印运输标签，并将其贴在有衬垫的信封上。",
      "64tve23zvqg0": "注意：",
      "64tve23zvyo0": "由于与锂电池相关的运输限制，如果您有理由怀疑电池可能有缺陷或故障，请不要寄送手机。",
      "64tve23zwak0": "我们无法退回与设备一起发送的任何配件或包装。",
      "64tve23zwgs0": "出售手机的下一步",
      "64tve23zwm80": "填写您的联系信息",
      "64tve23zwt00": "准备您的手机以供运输",
      "64tve23zwwk0": "您的设备将在到达时进行检查。如果您提供的信息不准确，我们将发送新的报价。您可以接受新报价或免费取回您的手机。"
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "购买渠道",
      "646ynp3ueas0": "需要激活，无法正常通话。--",
      "646ynp3uehw0": "请输入您手机的IMEI号",
      "646ynp3uem40": "拨号键盘输入*#06#查询手机IMEI"
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "查看估价"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "提示：手机/电子产品售价每周降低6%，您应该尽快售出",
      "647hqss760c0": "勾选同意",
      "647hqss764w0": "隐私协议",
      "647hqss76ac0": "服务政策",
      "647hqss76dg0": "我要下单",
      "647hqss76gw0": "预估成交价",
      "text1": '预估成交价',
      "text2": "预估价",
      "text3": "补贴",
      "dialogTitle": "提示",
      "dialogText": "单击确认按钮并检查您的电子邮件以进行下一步",
      "dialogBtn": "确认",
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "下单信息",
      "647kboa06ys0": "姓名",
      "647kboa078s0": "手机号",
      "647kboa07d00": "寄出地址",
      "647kboa07jk0": "国家",
      "647kboa07p80": "请选择",
      "647kboa08b40": "邮编",
      "647kboa08h00": "城市",
      "647kboa08zc0": "详细地址",
      "647kboa09440": "收款信息",
      "647kboa096w0": "邮箱验证",
      "647kboa09ao0": "邮箱号",
      "647kboa09dk0": "验证码",
      "647kboa09u40": "请输入",
      "647kboa09z80": "发送验证码",
      "647kboa0ak00": "输入正确的邮箱格式",
      "647kboa0aog0": "发送成功",
      "send": "已发送",
      "submit": "提交",
      "error": "验证码错误"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "回到首页"
    }
  },
  "blog": {
    "blogList": {
        "64wgr171lsk0": "观看",
        "64wgr171nq40": "暂无相关记录",
        "64wgr171av65": "发布日期",
    },
    "blogDetail": {
        "64wgr9y5r7s0": "观看",
        "64wgr171wdx9": "文章详情",
    }
  },

  "cookieNotice": {
    "title": "Cookie 使用提示",
    "description": "我们使用 Cookie 来提升您的浏览体验。继续使用本网站即表示您同意我们的",
    "cookiePolicy": "Cookie政策",
    "acceptAll": "接受所有 Cookie",
    "acceptNecessary": "仅接受必要 Cookie",
    "customize": {
      "title": "请选择您希望接受的Cookie类型：",
      "necessary": {
        "label": "必要 Cookie",
        "description": "这些 Cookie 是网站运行所必需的，无法关闭。"
      },
      "analytics": {
        "label": "分析 Cookie",
        "description": "这些 Cookie 帮助我们了解访问者如何与我们的网站互动。"
      },
      "marketing": {
        "label": "营销 Cookie",
        "description": "这些 Cookie 用于跟踪访客在不同网站上的活动，以显示相关广告。"
      }
    },
    "save": "保存设置",
    "cancel": "取消"
  }
 
}
